import {CLEAR_SWOT_ITEM, LOADING_PATCH_SWOT_ITEM, PATCH_ONE_SWOT_ITEM, SWOT_ITEM_FAIL} from "./actionTypes";

const initialState = {
    id:0,
    type:"",
    content:"",
    isLoading:false,
    hasFailed:false,
    isSend:false
}

const oneSwotIemReducer = (state = initialState, action) => {
    switch (action.type){
        case LOADING_PATCH_SWOT_ITEM:
            return {
                ...state,
                isLoading: true
            }
        case PATCH_ONE_SWOT_ITEM:
            return {
                ...state,
                id: action.payload.id,
                type:action.payload.type,
                content:action.payload.content,
                isLoading: false,
                isSend: true
            }
        case SWOT_ITEM_FAIL:
            return {
                ...state,
                hasFailed: true,
            }
        case CLEAR_SWOT_ITEM:
            return initialState
        default:
            return{
                ...state
            }
    }
}

export default oneSwotIemReducer;